import { Accordion, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CostAccordion = styled(Accordion)`
  width: 100%;

  ${Accordion.S.AccordionHeader} {
    ${Typography.S.Typography} {
      font-size: var(--size-14);
      font-weight: 700;
      text-decoration: none;
    }
  }

  ${Accordion.S.AccordionBody} {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 8px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

const CostSummaryCard = styled.div`
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;

const CostSummaryTitle = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const CostSummaryTitleLeft = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

const Label = styled.div`
  align-items: center;
  color: var(--color-fg-default);
  display: flex;
  gap: 8px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const SpentToDateRow = styled(Row)`
  border-radius: var(--size-border-radius-xl);
  font-size: 14px;
  font-weight: 700;
`;

const TotalRow = styled(Row)`
  align-items: center;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 0;
`;

const Value = styled.div`
  color: var(--color-fg-default);
  font-weight: 700;
  min-width: fit-content;
`;

const LcsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const LcsContentRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const LcsContentValue = styled.div`
  color: var(--color-fg-default);
  font-weight: 700;
  min-width: fit-content;
`;

export {
  Content,
  CostAccordion,
  CostSummaryCard,
  CostSummaryTitle,
  CostSummaryTitleLeft,
  Label,
  LcsContent,
  LcsContentRow,
  LcsContentValue,
  Row,
  SpentToDateRow,
  TotalRow,
  Value
};
